import React from 'react'
import Styles from '../../../Css/View360/View360.module.css'
import View360CommonStyle from '../../../Css/View360/View360Common.module.css'
import Switch from '@mui/material/Switch';
import { checkIsV2 } from '../../../utils/getAppVersion';

const MobileToggleHandler = ({isSpanish, handleHotSpotViewToggle, toggleHotspotView, initialHotspotProcessing }) => {
    const isV2 = checkIsV2()
    
    // If we're processing an initial hotspot, ensure the switch is forced to ON state
    const effectiveToggleState = initialHotspotProcessing ? true : toggleHotspotView;
    
    return (
        <div style={{right: isSpanish ? '4%' : 0}} className={Styles['hotspot-info-tag-left-mobile-view']}>
            <span>{isSpanish ? 'Puntos de acceso' : 'Hotspots'}</span>
            <Switch
                onChange={handleHotSpotViewToggle}
                checked={effectiveToggleState}
                size="small"
                sx={{
                    '& .MuiSwitch-thumb': {
                        backgroundColor: effectiveToggleState ? '#4600F2' : undefined
                    }
                }}
                className={[Styles["customSwitchTrack"]]}
                disabled={initialHotspotProcessing} // Disable toggle while processing initial hotspot
            />
        </div>
    )
}

export default MobileToggleHandler